import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";


import SignService from "../services/sign.service";


const list = {
  list: [],
  pageSize: 25,
  page: 0,
  total: 0,
  nextPage: 0
};

export const getSigns= createAsyncThunk(
  "auth/get_signs",
  async ({search}, thunkAPI) => {
    try {
      const data = await SignService.getSigns(search);
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getSign = createAsyncThunk(
  "auth/get_sign",
  async ({id}, thunkAPI) => {
    try {
      const data = await SignService.getSign(id);
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);


export const updateSign = createAsyncThunk(
  "auth/updateSign",
  async ( {sign},thunkAPI) => {
    try {
      const data = await SignService.updateSign(sign);
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);


const initialState = { data: list, loading: false};

const signSlice = createSlice({
  name: "sign",
  initialState,
  extraReducers: {

    [getSigns.pending]: (state, action) => {
      state.loading = true;
    },
    [getSigns.fulfilled]: (state, action) => {
      state.data = action.payload.data; 
      state.loading = false;
    },
    [getSigns.rejected]: (state, action) => {
      state.data = list
      state.loading = false;
    },

    [getSign.pending]: (state, action) => {
      state.loading = true;
    },
    [getSign.fulfilled]: (state, action) => {

      //is sign in list if so change it
      //else push it in

      let signs = state.data.list;
      let thisSign = signs.find((sign) => sign.id === action.payload.data.id)

      if(thisSign){
        Object.assign(thisSign,action.payload.data)
      }else{
        state.data.list.push(action.payload.data)
        state.data.total ++;
      }

      state.loading = false;
    },
    [getSign.rejected]: (state, action) => {
      state.data = list
      state.loading = false;
    },
    
    [updateSign.fulfilled]: (state, action) => {

      let signs = state.data.list;
      let thisSign = signs.find((sign) => sign.id === action.payload.data.id)

      thisSign.name = action.payload.data.name
      thisSign.description = action.payload.data.description
      thisSign.collection = action.payload.data.collection
      thisSign.administrator = action.payload.data.administrator

    },

  },
});


const { reducer } = signSlice;
export default reducer;